import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h4>Confirm Delete</h4>
        <p>This can't be undone</p>

        <div className="d-flex justify-content-center">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" className="ms-2">
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;